<template>
	<div>
		<div v-if="getMerchant.reservation_detail_show_bill">
			<popup-detail 
				id_ref="guestbill"
	    	direction="bottom" 
	    	:show="show"
	    	use_max_size
	    	wrapper_size="mobile"
	    	@close="toggleDetail">
	    	<template v-slot:body>
	    		<div v-if="is_load" class="w-100 my-4 text-center">
						<loader />
					</div>
					<template v-else>
						<div class="p-4" v-if="error != ''">
			      	<ErrorMessage :message="error" />
			    	</div>
			      <template v-else>
			      	<div class="p-4">
			      		<div class="row mb-3 pb-3 border-b-semi-grey">
			      			<div class="col-10 align-self-center">
			      				<p class="mb-0 body-1-4">Guest Bill</p>
			      			</div>
			      			<div class="col-2 text-right align-self-center">
			      				<div class="bg-white rounded-circle border-semi-grey cursor-pointer" style="display:inline-flex;padding:10px;" @click="toggleDetail()">
											<img src="../../../assets/img/icon/close.png" width="14" />
										</div>
			      			</div>
			      		</div>

				    		<!-- LIST BILL -->
					      <div 
					      	class="row no-gutters justify-content-start border-light-bottom py-2"
					      	:class="{'border-light-bottom' : bill_index+1 != bill.list.length, 'border-bottom': bill_index+1 == bill.list.length}"  
					      	v-for="(bill_item,bill_index) in bill.list" 
					      	:key="bill_index" >
					    		<div class="col-7">
					    			<p class="mb-0 body-3-3 font-bold">{{bill_item.description}}</p>
					    			<p class="mb-0 body-3-3">{{bill_item.remark}}</p>
					    		</div>
					    		<div class="col-5 text-right">
					    			<p class="mb-0 body-3-3 font-bold">{{$formatCurrency(bill_item.amount)}}</p>
					    			<p class="mb-0 body-3-3">{{$formatDate(bill_item.dates)}}</p>
					    		</div>
					      </div>

					      <!-- TOTAL BILL -->
					      <div class="row no-gutters pt-3 pb-1">
					    		<div class="col-7">
					    			<p class="mb-0 body-2-2 font-bold">{{$t('hotel.concierge.total')}}</p>
					    		</div>
					    		<div class="col-5 text-right">
					    			<p class="mb-0 body-2-2 font-bold">{{$formatCurrency(bill.total_bill)}}</p>
					    		</div>
					      </div>

					      <!-- PAYMENT  -->
				      <div class="row no-gutters py-1" @click="detail_payment = !detail_payment" v-if="!detail_payment">
				    		<div class="col-7">
				    			<div class="w-100 cursor-pointer">
				    				<p class="mb-0 d-inline-block align-middle body-2-2 font-bold text-green">{{$t('hotel.concierge.paid')}}</p>
				    				<p class="mb-0 d-inline-block align-middle body-3-3">({{$t('hotel.concierge.tap-to-see-detail-payment')}})</p>
				    			</div>
				    		</div>
				    		<div class="col-5 text-right">
				    			<p class="mb-0 body-2-2 font-bold text-green">{{$formatCurrency(bill.total_payment)}}</p>
				    		</div>
				      </div>
				      <div v-else  @click="detail_payment = !detail_payment" class="rounded-6 bg-white border-green my-2">
				    		<div class="p-2">
				    			<p class="mb-1 pb-1 border-bottom body-2-2 font-bold text-green">{{$t('hotel.concierge.paid')}}</p>
				    			<div 
				    			class="row no-gutters justify-content-start border-light-bottom py-2"
				    			:class="{'border-light-bottom' : payment_index+1 != bill.payment.length, 'border-bottom': payment_index+1 == bill.payment.length}" 
				    			v-for="(payment_item,payment_index) in bill.payment">
						    		<div class="col-7">
						    			<p class="mb-0 body-3-3 font-semibold">{{payment_item.description}}</p>
						    			<p class="mb-0 body-3-3">{{$formatDate(payment_item.dates)}}</p>
						    		</div>
						    		<div class="col-5 text-right">
						    			<p class="mb-0 body-3-3 font-semibold">{{$formatCurrency(payment_item.amount)}}</p>
						    		</div>
						      </div>
						      <div class="row no-gutters justify-content-start pt-2">
						    		<div class="col-7">
						    			<p class="mb-0 body-2-2 font-bold text-green">{{$t('hotel.concierge.total-paid')}}</p>
						    		</div>
						    		<div class="col-5 text-right">
						    			<p class="mb-0 body-2-2 font-bold text-green">{{$formatCurrency(bill.total_payment)}}</p>
						    		</div>
						      </div>
				    		</div>
				    	</div>

				    	<!-- BALANCE -->
				      <div class="row no-gutters pb-3 pt-1">
				    		<div class="col-7">
				    			<p class="mb-0 body-2-2 font-bold text-danger">{{$t('hotel.concierge.balance')}}</p>
				    		</div>
				    		<div class="col-5 text-right">
				    			<p class="mb-0 body-2-2 font-bold text-danger">{{$formatCurrency(bill.balance)}}</p>
				    		</div>
				      </div>
					    </div>
				    </template>
				  </template>
	    	</template>
	    </popup-detail>
		</div>
	</div>
</template>
<script type="text/javascript">
	import {mapGetters} from 'vuex'
	import {get} from '@/services/index.js'

	export default{
		data(){
			return{
				is_load: true,
				error: '',
				data: [],
				show: false,
				detail_payment:false
			}
		},
		computed:{
			...mapGetters(['getMerchant','getReservationActive']),
			bill(){
				let data = {
					list: [],
					payment: [],
					total_bill: 0,
					total_payment: 0,
					balance: 0
				}
				if(this.data.length > 0){
					this.data.forEach((item,index)=>{
						if(item.type == 'PAYMENT'){
							data.payment.push(item)
							data.total_payment += item.amount
						}else{
							data.list.push(item)
							data.total_bill += item.amount
						}
					})
					data.balance = data.total_bill-data.total_payment
				}

				return data
			}		
		},
		watch:{
			show(){
				if(this.show){
					this.loadGuestBill()
				}
			}
		},
		methods:{
			toggleDetail(){
				this.show = !this.show
			},
			loadGuestBill(){
				this.is_load = true
				this.error =  ''
				this.data = []
				get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}/${this.getReservationActive.folio}/guest-bill`,{
          merchant_id: this.getMerchant.id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
			},
			splitDataBill(is_payment=false){
      	let data_default = this.bills.filter(x=>{
      		if(is_payment){
      			return x.type == 'PAYMENT'
      		}else{
      			return x.type != 'PAYMENT'
      		}
      	})
				let data_sorted_by_date = data_default.sort((a,b)=>a.created_at-b.created_at)
				return data_sorted_by_date
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/GuestBill.vue